import { Component } from "react";
import { reportError } from "utils/api-error";

// Full-viewport "Something went wrong" UI for the ErrorBoundary.
// Style mirrors loading-screen.jsx so the two full-page replacement
// screens feel consistent.
export function ErrorFallback({ error }) {
    return (
        <div
            data-testid="error-fallback"
            className="min-h-screen flex items-center justify-center bg-platinumlight"
        >
            <div className="flex flex-col items-center gap-6 max-w-md text-center px-6">
                <div className="text-gobbyblue">
                    <span className="material-icons text-6xl">error_outline</span>
                </div>
                <h1 className="font-display text-2xl font-bold text-gobbyblue">
                    Something went wrong
                </h1>
                {error && error.message ? (
                    <p className="font-body text-gray-700">{error.message}</p>
                ) : null}
                <button
                    type="button"
                    onClick={() => window.location.reload()}
                    className="font-display rounded-full bg-gobbyblue text-white px-6 py-2 hover:opacity-90 transition-opacity"
                >
                    Refresh
                </button>
            </div>
        </div>
    );
}

// Top-level React error boundary. Place once near the root.
// componentDidCatch routes through reportError so errors land in the
// same structured console sink as API failures.
export default class ErrorBoundary extends Component {
    state = { error: null };

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        reportError(error, { componentStack: info.componentStack });
    }

    render() {
        if (this.state.error) {
            return <ErrorFallback error={this.state.error} />;
        }
        return this.props.children;
    }
}
